<template>
  <transition name="VERTICAL" mode="out-in">
    <div class="PAUSE-LIST-CONTAINER ">
      <div v-if="dayPauses.length" class="PAUSE-LIST">
        <day-pause-list-item
            v-for="(pause) in dayPauses"
            :key="pause.id"
            :id="pause.id"
            :pause="pause"
            class="LIST-ITEM"
            @onEdit="$emit('onEdit', pause)"
            @onDelete="$emit('onPauseDelete', pause)"
        />
      </div>
      <paused-leads-list-placeholder v-else/>
    </div>
  </transition>
</template>

<script>
import DayPauseListItem from './DayPauseListItem';
import PausedLeadsListPlaceholder from '../PausedLeadsList/PausedLeadsListPlaceholder';

export default {
  name: 'day-pause-list',
  components: {
    DayPauseListItem,
    PausedLeadsListPlaceholder,
  },
  props: {
    dayPauses: {
      type: Array,
      default: () => [],
    },
    isFetching: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  @import "~@/views/Dashboard/constants";

  .PAUSE-LIST {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    overflow-y: hidden;
  }
  .PAUSE-LIST-CONTAINER {
    @include responsive(border-left, none, 1px solid $color-gray30);
    @include responsive(border-right, none, 1px solid $color-gray30);
    position: relative;
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    background-color: white;
    border-top: 1px solid $color-gray30;
    border-bottom: none;
    overflow: auto;
    margin-left: $unit;
  }
  .LIST-ITEM {
    transition: all $transition-duration;
  }
</style>
